"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSearchTermsProperty = exports.searchTermsPropertyDefinition = void 0;
exports.searchTermsPropertyDefinition = {
    view: {
        label: 'Custom search terms',
        hint: 'Using custom search terms allows you to promote this content piece in our onsite search. Alternative spellings are a perfect use case for this feature - e.g. Neymar Jr\'s 5 (as an alternative to Neymar Jr\'s Five official title)',
    },
    constraints: [],
    type: 'text',
    multiple: true,
    name: 'search-terms',
};
const isSearchTermsProperty = (prop) => {
    return prop.name === exports.searchTermsPropertyDefinition.name;
};
exports.isSearchTermsProperty = isSearchTermsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXRlcm1zLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2VhcmNoLXRlcm1zLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLHFCQUFxQjtRQUM1QixJQUFJLEVBQUUsc09BQXNPO0tBQzdPO0lBQ0QsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGNBQWM7Q0FDVyxDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=